import { buildScopedI18n } from '../../utils/buildScopedI18n';
import tasksEsCL from './locales/es-CL.json';
import tasksEnUS from './locales/en-US.json';
import tasksPtBR from './locales/pt-BR.json';

export const tasksI18n = buildScopedI18n({
  esCL: tasksEsCL,
  enUS: tasksEnUS,
  ptBR: tasksPtBR,
});
